import React from 'react';

import DataContainer from 'Components/UI/DataContainer';

import FlowView from './FlowView';
import { useFlowContext } from './FlowContext';

const FlowContainer = () => {
  const { loading, loadingError } = useFlowContext();

  return (
    <DataContainer
      loading={loading}
      loadingError={loadingError}
      component={FlowView}
    />
  );
};

export default FlowContainer;
